{
  "metadata": {
    "id": "opencode-light",
    "name": "OpenCode",
    "description": "Портировано из темы «OpenCode» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "opencode.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/opencode.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 28.5,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.45,
      "paletteMaxS": 0.537,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.9,
      "syntaxVsTextMinDeltaE": 29.0,
      "chartsMinDeltaE": 41.8,
      "textSeparationDeltaE": 22.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "number",
          "deltaE": 0.0
        },
        {
          "a": "keyword",
          "b": "type",
          "deltaE": 15.2
        },
        {
          "a": "number",
          "b": "type",
          "deltaE": 15.2
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#3b7dd8",
      "hover": "#3570c2",
      "active": "#3066b1",
      "foreground": "#000000",
      "muted": "#3b7dd880",
      "emphasis": "#3b7dd8"
    },
    "surface": {
      "background": "#ffffff",
      "foreground": "#1a1a1a",
      "muted": "#d1d1d1",
      "mutedForeground": "#4a4a4a",
      "elevated": "#bababa",
      "elevatedForeground": "#1a1a1a",
      "raised": "#9f9f9f",
      "raisedForeground": "#1a1a1a",
      "overlay": "#ffffff33",
      "subtle": "#e8e8e8"
    },
    "interactive": {
      "border": "#979797",
      "borderHover": "#bfbfbf",
      "borderFocus": "#3b7dd8",
      "selection": "#1a1a1a24",
      "selectionForeground": "#1a1a1a",
      "focus": "#3b7dd859",
      "focusRing": "#3b7dd847",
      "cursor": "#1a1a1a",
      "hover": "#1a1a1a17",
      "active": "#1a1a1a24"
    },
    "status": {
      "error": "#d1383d",
      "errorForeground": "#ffffff",
      "errorBackground": "#d1383d1a",
      "errorBorder": "#d1383d59",
      "warning": "#a26a1e",
      "warningForeground": "#ffffff",
      "warningBackground": "#a26a1e1a",
      "warningBorder": "#a26a1e59",
      "success": "#34844b",
      "successForeground": "#ffffff",
      "successBackground": "#34844b1a",
      "successBorder": "#34844b59",
      "info": "#2e808d",
      "infoForeground": "#ffffff",
      "infoBackground": "#2e808d1a",
      "infoBorder": "#2e808d59"
    },
    "pr": {
      "open": "#34844b",
      "draft": "#5a5a5a",
      "blocked": "#a26a1e",
      "merged": "#c98425",
      "closed": "#d1383d"
    },
    "syntax": {
      "base": {
        "background": "#d1d1d1",
        "foreground": "#1a1a1a",
        "comment": "#5a5a5a",
        "keyword": "#7b5116",
        "string": "#276338",
        "number": "#7b5116",
        "function": "#23616b",
        "variable": "#aa272b",
        "type": "#6f5414",
        "operator": "#23616b"
      },
      "tokens": {
        "commentDoc": "#5a5a5a",
        "stringEscape": "#23616b",
        "keywordImport": "#7b5116",
        "storageModifier": "#7b5116",
        "functionCall": "#23616b",
        "method": "#23616b",
        "variableProperty": "#23616b",
        "variableOther": "#aa272b",
        "variableGlobal": "#7b5116",
        "variableLocal": "#23616b",
        "parameter": "#aa272b",
        "constant": "#7b5116",
        "class": "#6f5414",
        "className": "#6f5414",
        "interface": "#6f5414",
        "struct": "#6f5414",
        "enum": "#6f5414",
        "typeParameter": "#6f5414",
        "namespace": "#6f5414",
        "module": "#7b5116",
        "tag": "#7b5116",
        "jsxTag": "#7b5116",
        "tagAttribute": "#23616b",
        "tagAttributeValue": "#276338",
        "boolean": "#7b5116",
        "decorator": "#7b5116",
        "label": "#23616b",
        "regexp": "#276338"
      }
    },
    "charts": {
      "series": [
        "#3b7dd8",
        "#2e808d",
        "#34844b",
        "#a26a1e",
        "#d1383d"
      ]
    },
    "chat": {
      "background": "#ffffff",
      "userMessage": "#1a1a1a",
      "userMessageBackground": "#bababa",
      "assistantMessage": "#1a1a1a",
      "assistantMessageBackground": "#d1d1d1",
      "timestamp": "#5a5a5a",
      "divider": "#979797",
      "typing": "#5a5a5a"
    },
    "loading": {
      "spinner": "#3b7dd8",
      "spinnerTrack": "#d1d1d1",
      "skeleton": "#d1d1d1",
      "shimmer": "#c6c6c6"
    },
    "tools": {
      "background": "#d1d1d1",
      "border": "#979797",
      "headerHover": "#c8c8c8",
      "icon": "#2a72d4",
      "title": "#1a1a1a",
      "description": "#5a5a5a",
      "edit": {
        "added": "#34844b",
        "addedBackground": "#34844b1a",
        "removed": "#d1383d",
        "removedBackground": "#d1383d1a",
        "modified": "#2e808d",
        "modifiedBackground": "#2e808d1a",
        "lineNumber": "#5a5a5a"
      }
    },
    "markdown": {
      "heading1": "#1a1a1a",
      "heading2": "#1a1a1a",
      "heading3": "#1a1a1a",
      "heading4": "#1a1a1a",
      "link": "#2e75d5",
      "linkHover": "#3570c2",
      "inlineCode": "#276338",
      "inlineCodeBackground": "#d1d1d1",
      "blockquote": "#5a5a5a",
      "blockquoteBorder": "#979797",
      "listMarker": "#377ad7",
      "bold": "#1a1a1a",
      "italic": "#1a1a1ae6",
      "strikethrough": "#5a5a5a",
      "hr": "#979797"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a4238",
        "foreground": "#ffffff",
        "contrast": 7.2
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d29e92",
        "foreground": "#000000",
        "contrast": 9.05
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#95753a",
        "foreground": "#000000",
        "contrast": 4.88
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d3d373",
        "foreground": "#000000",
        "contrast": 13.34
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718f42",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#4fbd4c",
        "foreground": "#000000",
        "contrast": 8.72
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dc9f",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#409676",
        "foreground": "#000000",
        "contrast": 5.84
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#93dcd7",
        "foreground": "#000000",
        "contrast": 13.46
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4896b9",
        "foreground": "#000000",
        "contrast": 6.34
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#364f88",
        "foreground": "#ffffff",
        "contrast": 7.98
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#353eb0",
        "foreground": "#ffffff",
        "contrast": 8.51
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8d6bc0",
        "foreground": "#000000",
        "contrast": 5.0
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b846b3",
        "foreground": "#ffffff",
        "contrast": 4.6
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d292be",
        "foreground": "#000000",
        "contrast": 8.6
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#b74273",
        "foreground": "#ffffff",
        "contrast": 5.2
      }
    ]
  }
}
